import React from 'react';
import { NavLink } from 'react-router-dom';

const FundsCrumb = () => <NavLink to="/core/funds">Fund Management</NavLink>;

export default FundsCrumb;
